var map = {
	"./casinogames.json": [
		950,
		32
	],
	"./casinogames31.json": [
		951,
		33
	],
	"./casinogames33.json": [
		952,
		34
	],
	"./casinogames39.json": [
		953,
		35
	],
	"./casinogames47.json": [
		954,
		36
	],
	"./casinogames61.json": [
		955,
		37
	],
	"./instantgames.json": [
		956,
		38
	],
	"./instantgames31.json": [
		957,
		39
	],
	"./instantgames33.json": [
		958,
		40
	],
	"./instantgames39.json": [
		959,
		41
	],
	"./instantgames47.json": [
		960,
		42
	],
	"./instantgames61.json": [
		961,
		43
	],
	"./instantgamesBKP.json": [
		962,
		44
	],
	"./jsonBackUpFiles/casinogames-backup.json": [
		963,
		45
	],
	"./jsonBackUpFiles/casinogames31BKP.json": [
		964,
		46
	],
	"./jsonBackUpFiles/casinogames33BKP.json": [
		965,
		47
	],
	"./jsonBackUpFiles/casinogames39BKP.json": [
		966,
		48
	],
	"./jsonBackUpFiles/casinogames47BKP.json": [
		967,
		49
	],
	"./jsonBackUpFiles/slotgames-backup.json": [
		968,
		50
	],
	"./populargames.json": [
		969,
		51
	],
	"./populargames31.json": [
		970,
		52
	],
	"./populargames33.json": [
		971,
		53
	],
	"./populargames39.json": [
		972,
		54
	],
	"./populargames47.json": [
		973,
		55
	],
	"./populargames61.json": [
		974,
		56
	],
	"./slotgames.json": [
		975,
		57
	],
	"./slotgames31.json": [
		976,
		58
	],
	"./slotgames33.json": [
		977,
		59
	],
	"./slotgames39.json": [
		978,
		60
	],
	"./slotgames47.json": [
		979,
		61
	],
	"./slotgames61.json": [
		980,
		62
	],
	"./teenpatti.json": [
		374
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 852;
module.exports = webpackAsyncContext;